import { INTEREST_CATALOG } from "./interest.catalog";

/**
 * ======================================================
 * HELPERS DU MODULE INTERETS
 * ======================================================
 */

export const INTERESTS_BY_ID = Object.fromEntries(
  INTEREST_CATALOG.map((interest) => [interest.id, interest])
);

const LEGACY_INTEREST_ALIASES = {
  afterwork: "sorties",
  business: "pro",
  bachata: "danse",
  bachatta: "danse",
  bike: "sport",
  boxe: "sport",
  camping: "nature",
  canoe: "nature",
  cinema: "culture",
  comedy: "culture",
  concert: "musique",
  cuisine: "food",
  culture: "culture",
  dance: "danse",
  fair: "sorties",
  family: "famille",
  festival: "sorties",
  fitness: "bienetre",
  food: "food",
  game: "gaming",
  gaming: "gaming",
  hike: "nature",
  hiking: "nature",
  hiphop: "danse",
  humour: "culture",
  kids: "famille",
  kiz: "danse",
  kizomba: "danse",
  market: "sorties",
  music: "musique",
  musique: "musique",
  nature: "nature",
  networking: "pro",
  party: "sorties",
  photo: "culture",
  photographie: "culture",
  pro: "pro",
  randonnee: "nature",
  randonee: "nature",
  roadtrip: "voyage",
  roadtripfr: "voyage",
  road_trip: "voyage",
  run: "sport",
  running: "sport",
  salsa: "danse",
  show: "culture",
  sport: "sport",
  spectacle: "culture",
  surf: "sport",
  swing: "danse",
  tango: "danse",
  tarraxo: "danse",
  travel: "voyage",
  trip: "voyage",
  velo: "sport",
  voyage: "voyage",
  wellness: "bienetre",
  workshop: "pro",
  yoga: "bienetre",
};

export function normalizeInterestId(value) {
  const normalized = String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "")
    .replace(/-/g, "");

  return LEGACY_INTEREST_ALIASES[normalized] || normalized;
}

export function getInterestMeta(value) {
  const normalizedId = normalizeInterestId(value);

  return (
    INTERESTS_BY_ID[normalizedId] || {
      id: normalizedId,
      label: normalizedId || "Interet",
      emoji: "\u2728",
      group: "other",
    }
  );
}

export function getInterestOptions() {
  return INTEREST_CATALOG;
}

export function mergeLegacyInterests(hashtags = [], activities = []) {
  return Array.from(
    new Set(
      [...hashtags, ...activities]
        .map(normalizeInterestId)
        .filter((value) => INTERESTS_BY_ID[value])
    )
  );
}
